var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.5C14.8871 40.5 7.5 33.1129 7.5 24C7.5 14.8871 14.8871 7.5 24 7.5C33.1129 7.5 40.5 14.8871 40.5 24C40.5 33.1129 33.1129 40.5 24 40.5ZM24 37.2C27.5009 37.2 30.8583 35.8093 33.3338 33.3338C35.8093 30.8583 37.2 27.5009 37.2 24C37.2 20.4991 35.8093 17.1417 33.3338 14.6662C30.8583 12.1907 27.5009 10.8 24 10.8C20.4991 10.8 17.1417 12.1907 14.6662 14.6662C12.1907 17.1417 10.8 20.4991 10.8 24C10.8 27.5009 12.1907 30.8583 14.6662 33.3338C17.1417 35.8093 20.4991 37.2 24 37.2ZM15.75 25.65H30.6V28.95H24V33.9L15.75 25.65ZM24 19.05V14.1L32.25 22.35H17.4V19.05H24Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteEmptyIcon);
export default __webpack_public_path__ + "static/media/quoteEmptyIcon.6efe654f0ad921f86847f8cfd87a1c17.svg";
export { ForwardRef as ReactComponent };